export function getScopedPatientAppointments(appointments = [], activeMode, doctorId) {
  if (activeMode === "everything") return appointments;

  if (activeMode === "personal") {
    return appointments.filter(appointment =>
      appointment.doctor_id === doctorId &&
      (!appointment.clinic_id || appointment.clinic_id === "personal")
    );
  }

  return appointments.filter(appointment => appointment.clinic_id === activeMode);
}
